import './wdyr'; // <--- first import

import * as React from 'react'
import * as ReactDOM from 'react-dom'
import './index.css'
import App from './containers/App'
import registerServiceWorker from './registerServiceWorker'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history, persistor, rrfConfig } from './app-store'
import { PersistGate } from 'redux-persist/lib/integration/react';
import { ReactReduxFirebaseProvider, getFirebase } from 'react-redux-firebase'
import { firebaseMain } from './firebase_client'


registerServiceWorker()

const mainElement = document.createElement('div');
mainElement.classList.add('root');
document.body.appendChild(mainElement);

const rrfProps = {
   firebase: firebaseMain,
   config: rrfConfig,
   dispatch: store.dispatch
}

const render =(Component: any)=> {
    return ReactDOM.render(
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <Component />

          </ConnectedRouter>
        </PersistGate>
      </ReactReduxFirebaseProvider>
    </Provider>,
    document.getElementById('root')
  )
}

render(App)




// WEBPACK FOOTER //
// ./src/index.tsx